import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { PingResponse } from '../../models/ping-response';

@Injectable({
    providedIn: 'root'
})
export class PingApiService {
    baseUrl: string = environment.apiUrl;

    pingSuffix = 'ping';

    constructor(private httpClient: HttpClient) {}

    ping() {
        return this.httpClient.get<PingResponse>(`${this.baseUrl}${this.pingSuffix}`);
    }
}
